import {
  DOWNLOAD_MAX_CAP_REPORT_FAILURE,
  DOWNLOAD_MAX_CAP_REPORT_REQUEST,
  DOWNLOAD_MAX_CAP_REPORT_RESET,
  DOWNLOAD_MAX_CAP_REPORT_SUCCESS,
} from "redux/actions/action-type";

const initialState = {
  isDownloadLoading: false,
  isDownloadSuccess: false,
  isDownloadFail: false,
  downloadMaxCapResponse: {},
};

export const downloadMaxCapReportReducer = (
  state = initialState,
  { type, downloadMaxCapResponse },
) => {
  switch (type) {
    case DOWNLOAD_MAX_CAP_REPORT_REQUEST:
      return {
        ...state,
        isDownloadLoading: true,
        isDownloadSuccess: false,
        isDownloadFail: false,
      };
    case DOWNLOAD_MAX_CAP_REPORT_SUCCESS:
      return {
        ...state,
        downloadMaxCapResponse: downloadMaxCapResponse,
        isDownloadLoading: false,
        isDownloadSuccess: true,
        isDownloadFail: false,
      };
    case DOWNLOAD_MAX_CAP_REPORT_FAILURE:
      return {
        ...state,
        downloadMaxCapResponse: downloadMaxCapResponse,
        isDownloadLoading: false,
        isDownloadSuccess: false,
        isDownloadFail: true,
      };
    case DOWNLOAD_MAX_CAP_REPORT_RESET:
      return { ...initialState };
    default:
      return { ...state };
  }
};
